{
  "previous": "Назад",
  "next": "Далее",
  "complete": "Завершить",
  "verifyAndCheckIn": "Подтвердить и зарегистрироваться",
  "loading": {
    "retrievingLocation": "Определение местоположения...",
    "retrievingWarehouse": "Загрузка данных склада..."
  },
  "validation": {
    "fieldRequired": "Это поле обязательно для заполнения",
    "fieldRequiredWithLabel": "Поле «{label}» обязательно",
    "phoneInvalid": "Неверный номер телефона",
    "phoneInvalidWithExample": "Неверный номер телефона (пример: {example})"
  }
}
